import React from 'react';
import { statusColors } from '../../tokens';

const StatusBadge = ({ status }) => {
  const statusLabels = {
    new: { ...statusColors.new, label: 'NEW' },
    reviewing: { ...statusColors.reviewing, label: 'REVIEWING' },
    approved: { ...statusColors.approved, label: 'APPROVED' },
    declined: { ...statusColors.declined, label: 'DECLINED' },
  };
  const style = statusLabels[status] || statusLabels.new;
  return (
    <span style={{
      backgroundColor: style.bg,
      color: style.text,
      padding: '4px 10px',
      borderRadius: '4px',
      fontSize: '11px',
      fontWeight: '600',
      letterSpacing: '0.5px'
    }}>
      {style.label}
    </span>
  );
};

export default StatusBadge;
